import React, { useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    LinearProgress,
    Typography,
} from '@material-ui/core';

import { PluginContext } from '../contexts';

import { makeStyles, withStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        height: "70vh",
        marginBottom: theme.spacing(6),
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    }
}));

export const PageLoader = ({
    aphorism,
    enableAphorism,
    ...props }) => {

    const classes = useStyles();

    const {
        getAssetUrl
    } = useContext(PluginContext);

    return (
        <>
            <LinearProgress color="primary" />
            {enableAphorism &&
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    minHeight: 540,
                    height: "70vh"
                }}>
                    <img src={getAssetUrl("images/loading.gif")} style={{ width: 400, height: 400 }} />
                    <Typography variant="h5" align="center" style={{ width: 600 }}>
                        {aphorism.phrase}
                    </Typography>
                    <Typography variant="subtitle1" align="center" style={{ width: 600 }}>
                        {`${aphorism.author}`}
                    </Typography>
                </div>
            }
        </>
    )
}